// Tiny presentation helpers shared by the property-detail surfaces
// (mobile hero, desktop right column, action grid). Kept together so
// the page file stays composition-only — these are not React, not
// stateful, and only ever consumed by detail-page components.

import { formatPrice } from "@/features/property/utils/format-price";
import type { BrokerageFeeType, Property } from "@/types/property";

export function pricePerSqmLabel(property: Property): string | null {
  if (property.area <= 0) return null;
  return `≈ ${formatPrice(Math.round(property.price / property.area), property.listingType)} / m²`;
}

/**
 * Human label for a listing's brokerage commission — "2%", "2 tháng", or a
 * formatted VND amount ("150 triệu"). Returns null when no fee is set. JS
 * numbers carry no trailing zeros, so 1.5 → "1.5" and 2 → "2" naturally.
 */
export function formatBrokerageFee(
  type: BrokerageFeeType | null,
  value: number | null,
): string | null {
  if (type === null || value === null) return null;
  switch (type) {
    case "PERCENT":
      return `${value}%`;
    case "MONTHS":
      return `${value} tháng`;
    case "AMOUNT":
      return formatPrice(value, "SALE");
  }
}

export function propertyTypeBadgeText(property: Property): string {
  return property.listingType === "SALE" ? "Bán" : "Cho thuê";
}

export function brokerInitials(brokerId: number | null): string {
  if (brokerId === null) return "—";
  // Without broker name lookup, fall back to a code-style initials chip.
  return `#${brokerId}`;
}
